import { type QueryFunctionContext, useInfiniteQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import * as qs from 'qs';

import { apiClient } from '@services/apiClient';

import type { IWhatsNewList, IWhatsNewListKeys } from '../model/whatsNewList';

export const whatsNewListKey = (keys: IWhatsNewListKeys) => [
  'whatsNewList',
  keys?.searchValue,
  keys?.isFavorite,
];

const whatsNewListFn = ({
  queryKey,
  pageParam = 1,
}: QueryFunctionContext<ReturnType<typeof whatsNewListKey>, number>) => {
  const params = {
    search: queryKey[1],
    filter: { isFavorite: queryKey[2] },
    page: pageParam,
    limit: 10,
  };

  return apiClient
    .get(`${APP_API_URL_V2}customer-dashboard-v2/whats-new`, {
      params,
      paramsSerializer: {
        serialize: (params) => qs.stringify(params),
      },
    })
    .then(({ data }: AxiosResponse<IWhatsNewList>) => ({
      whatsNewList: data.data,
      ...data.pagination,
    }));
};

export const useWhatsNewListInfiniteQuery = (keys: IWhatsNewListKeys) => {
  return useInfiniteQuery({
    queryKey: whatsNewListKey(keys),
    queryFn: whatsNewListFn,
    getNextPageParam: ({ onLastPage, currentPage }) => (!onLastPage ? currentPage + 1 : undefined),
    refetchOnWindowFocus: false,
  });
};
